
export * as AppMobile from "./lib/utils/appMobile"
export { getButtonActionByActionType } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-consumer-deploy-prod/libs/shared/data-access/src/lib/utils/actions.ts"
export { getVariantByActionStyle } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-consumer-deploy-prod/libs/shared/data-access/src/lib/utils/actions.ts"